import { useCallback, useEffect, useState } from "react";
export const useIntermediateState = (value, setValue) => {
    const [hasLocalChanges, setHasLocalChanges] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const settleValue = useCallback(() => {
        setValue(localValue);
        setHasLocalChanges(false);
    }, [setValue, localValue]);
    const setLocalValueAndTrackChanges = useCallback((newValue) => {
        setHasLocalChanges(true);
        setLocalValue(newValue);
    }, [setLocalValue]);
    useEffect(() => {
        if (!hasLocalChanges)
            setLocalValue(value);
    }, [value, hasLocalChanges, localValue]);
    return [localValue, setLocalValueAndTrackChanges, settleValue];
};
